import React, { useState, useEffect } from "react";
import Header from "../header2/Header";
import { motion } from "framer-motion";
import Slider from "react-slick";
//import AddIcon from "@mui/icons-material/Add";
//import RemoveIcon from "@mui/icons-material/Remove";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Seo from "../seo/Seo";
import AddToCartSecu from "../../../features/frontend/addtocartsecu/AddToCartSecur";
import { loadProducts } from "../../../features/frontend/addtocartsecu/thunk-productsecu";
import { useDispatch } from "react-redux";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { NavLink, useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import CustomerContext from "../blog-folder/CustomerContext";
import Typography from "@mui/material/Typography";

const Security = () => {
  const { handleOpen } = React.useContext(CustomerContext);
  const [inputData, setInputData] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadProducts());
  }, [dispatch]);
  // useState section start--------------------------------------

  // acoordian button
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);

  //  useState section end----------------------------------------
  const settings3 = {
    infinite: true,
    speed: 1000,
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    cssEase: "linear",
    autoplaySpeed: 2000,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  var settings2 = {
    infinite: true,

    autoplay: true,

    cssEase: "linear",
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          // dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Slider section start-----------------------------------------
  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div className="security-slider-custome-button-next" onClick={onClick}>
        <KeyboardArrowRightIcon className="forword-arrow" />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div className="security-slider-custome-button-prev" onClick={onClick}>
        <KeyboardArrowLeftIcon className="backword-arrow" />
      </div>
    );
  }
  // Slider section start-----------------------------------------

  // -------------------
  const handleSubmit = (event) => {
    event.preventDefault();

    // Assuming you have predefined pages based on input values
    const pages = {
      home: "/",
      domain: "/domain",
      "domain booking": "/domain-booking",
      "domain available": "/domain-available",
      "domain transfer": "/domain-transfer",
      "domain book": "/domain-booking",

      hosting: "/hosting-service",
      "shared hosting": "/shared-hosting-provider",
      "wordpress hosting": "/wordpress-hosting-services",
      "dedicated hosting": "/dedicated-hosting-services",
      "vps hosting": "/vps-hosting-services",
      security: "/web-security-services",
      "standard ssl": "/standard-ssl",
      "wildcard ssl": "/wildcard-ssl",
      "organization validation ssl": "/organization-validation-ssl",
      "extended validation ssl": "/extented-validation-ssl",
      email: "/email-hosting-provider",
      "google workspace": "/google-workspace-service-provider",
      microsoft: "/microsoft-365-service-provider",
      "rediff mail": "/rediff-mail",
      branding: "/branding-agency",
      "branding consulting firm": "/branding-consulting-firm",
      "branding strategy consultant": "/brand-strategy-consultant",
      "brand positioning agency": "/brand-positioning-agency",
      "brand identity agency": "/brand-identity-agency",
      "branding communication agency": "/branding-communication-agency",
      "performance marketing company": "/performance-marketing-company",
      "social media marketing agency": "/social-media-marketing-agency",
      "search engine marketing agency": "/search-engine-marketing-agency",
      "organic marketing agency": "/organic-marketing-agency",
      "search engine optimization services":
        "/search-engine-optimization-services",
      "search engine optimization": "/search-engine-optimization-services",
      sem: "/search-engine-optimization-services",
      "social media optimization agency": "/social-media-optimization-agency",
      "creative content agency": "/creative-content-agency",
      "display advertising agency": "/display-advertising-agency",
      "website development company": "/website-development-company",
      "print design": "/print-design-agency",
      "content marketing": "/content-marketing-agency",
      "social media": "/social-media-agency",
      "organics marketing": "/organic-social-media-agency",
      "paid marketing": "/paid-marketing-agency",
      "web development": "/web-development-agency",
      "wordpress development": "/wordpress-development-agency",
      "ecommerce development": "/ecommerce-development-agency",
      gallery: "/our-gallery",
      "case studies": "/case-studies",
      blog: "/blog",
      careers: "/career",
      b2b: "/b2b-digital-marketing-agency",
      b2c: "/b2c-digital-marketing-agency",
      power: "/power-digital-marketing-agency",
      hardware: "/hardware-digital-marketing-agency",
      healthcare: "/hosting-service",
      automotive: "/automotive-digital-marketing-agency",
      tech: "/tech-digital-marketing-agency",
      manufacture: "/manufacturing-digital-marketing-agency",
      "raw material": "/raw-material-digital-marketing-agency",
      "real estate": "/realestate-digital-marketing-agency",
      ecommerce: "/ecommerce-digital-marketing-agency",
      "interial furniture": "/interior-furniture-digital-marketing-agency",
      education: "/education-digital-marketing-agency",
      lifestyle: "/lifestyle-digital-marketing-agency",
      "seo services": "/search-engine-optimization-services",
      seo: "/search-engine-optimization-services",
      "web development": "/web-development-agency",
      "search engine marketing": "/search-engine-marketing-agency",
      "smm service": "/paid-marketing-agency",
      smm: "/paid-marketing-agency",
      "social media marketing": "/paid-marketing-agency",
      "social media optimization": "/organic-social-media-agency",
      "smo service": "/organic-social-media-agency",
      smo: "/organic-social-media-agency",
      "content marketing": "/content-marketing-agency",
      "organic marketing": "/organic-marketing-agency",
      "brand marketing": "/branding-agency",
      "facebook optimization": "/social-media-agency",
      "instagram optimization": "/social-media-agency",
      "google adwords": "/performance-marketing-company",
      "adwords optimization": "/performance-marketing-company",
      "ads optimization": "/performance-marketing-company",
      "wordpress development": "/wordpress-development-agency",
      "website development": "/web-development-agency",
      website: "/web-development-agency",
      "ecommerce website": "/web-development-agency",
      "paid marketing": "/creative-content-agency",
      "paid advertising": "/creative-content-agency",
      "display ads": "/display-advertising-agency",
      "search ads": "/search-engine-optimization-services",
      "youtube ads": "/branding-consulting-firm",
      "youtube marketing": "/brand-positioning-agency",
      "print design": "/print-design-agency",
      "website design": "/website-development-company",
      "web design": "/website-development-company",
      "web optimization": "/website-development-company",
      "customized website": "/website-development-company",
      "rank keywords": "/search-engine-optimization-services",
      "seo ramking": "/search-engine-optimization-services",
      contact: "/contact",
    };

    // Get the corresponding page based on the input value
    const inputValue = inputData.toLowerCase().trim();

    // Find a matching page based on input
    const matchingPage = Object.keys(pages).find((key) =>
      key.includes(inputValue)
    );

    if (matchingPage) {
      // Redirect to the matched page
      navigate(pages[matchingPage]);
    } else {
      // Navigate to the home page if no match found
      navigate(pages["home"]);
    }
  };

  // Define your Schema.org data
  const schema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "G-Rank",
        item: "https://www.grank.co.in/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Web Security Services",
        item: "https://www.grank.co.in/web-security-services",
      },
    ],
  };

  return (
    <>
      <Seo
        title="Web Security Provider in Bangalore | Hyderabad"
        description="Web security provider in bangalore and hyderabad. Explore our Security section to discover a range of robust solutions designed to safeguard your online assets. "
        name="Company name."
        type="article"
        YahooSeeker="INDEX, FOLLOW"
        msnbot="INDEX, FOLLOW"
        googlebot="INDEX, FOLLOW"
        keywords="best website security service provider in India,
        best Website security service,
        best Web security"
        searchengines="ALL"
        canonical="https://www.grank.co.in/web-security-services"
        schema={schema}
      ></Seo>

      <section className="section-top">
        <Header />
        {/* banner start */}
        <div
          className="creative-banner-display-ads"
          style={{ backgroundColor: "#fff", position: "relative" }}
        >
          <img
            className="img-fluid w-100 mobile-none"
            src="assest/photos/security/security-banner.png"
            alt="grank"
            title="security"
          />
          <img
            className="img-fluid w-100 desktop-none"
            src="assest/photos/security/security-banner-mobile.png"
            alt="grank"
            title="security"
          />

          <div className="security-banner-div">
            <h5 className="waviy-sec ">
              <span>
                Secure
                <br />
                Your Data
              </span>
            </h5>
            <h1 style={{ fontSize: "24px", marginBottom: "0px" }}>
              Web Security Provider
            </h1>
            <h2>
              We create and build flexible & creative design
              <br /> in your budget
            </h2>

            <h3 onClick={handleOpen}>
              <NavLink to="">Find Out More</NavLink>
            </h3>
            <Breadcrumbs
              className="breadcrumbs"
              aria-label="breadcrumb"
              style={{ paddingTop: "40px" }}
            >
              <NavLink
                style={({ isActive }) => ({
                  color: isActive ? "#000" : "#000",
                })}
                to="/"
              >
                <p>Home</p>
              </NavLink>

              <Typography color="#000">Security</Typography>
            </Breadcrumbs>
          </div>
        </div>
        {/* banner end */}
        {/* section2 Start */}
        <section className="">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <motion.h4
                  className="security-circle-heading"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  SSL Features
                </motion.h4>
              </div>
              <div className="col-12 col-md-4 col-lg-4">
                <motion.div
                  className="security-circle-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8 }}
                >
                  <div>
                    <img
                      className="img-fluid"
                      src="assest/photos/security/security-icon1.png"
                      alt="grank"
                      title="security"
                    />
                  </div>
                  <h4>Confidentiality</h4>
                  <p>
                    Guaranteed via encryption,
                    <br /> which complicates data to
                    <br /> prevent unauthorized <br />
                    decryption.
                  </p>
                </motion.div>
              </div>
              <div className="col-12 col-md-4 col-lg-4">
                <motion.div
                  className="security-circle-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  <div>
                    <img
                      className="img-fluid"
                      src="assest/photos/security/security-icon2.png"
                      alt="grank"
                      title="security"
                    />
                  </div>
                  <h4>Integrity</h4>
                  <p>
                    Establish encryption
                    <br /> methods to prevent
                    <br /> unauthorized
                    <br />
                    alterations.
                  </p>
                </motion.div>
              </div>
              <div className="col-12 col-md-4 col-lg-4">
                <motion.div
                  className="security-circle-div"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  <div>
                    <img
                      className="img-fluid"
                      src="assest/photos/security/security-icon3.png"
                      alt="grank"
                      title="security"
                    />
                  </div>
                  <h4>Authentication</h4>
                  <p>
                    Establish through highly
                    <br /> secure digital authenticity
                    <br />
                    certificates, minimizing the <br />
                    risk of falsification.
                  </p>
                </motion.div>
              </div>
            </div>
          </div>
        </section>
        {/* section2 end */}
        {/* blue text start */}
        <section className="security-blue-section">
          <div className="container">
            <div className="row ">
              <div className="col-12 security-blue-div">
                <motion.h4
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  About SSL Security 
                </motion.h4>

                <motion.p
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  A standard technology used to establish a secure internet
                  connection by encrypting data transmitted between a website
                  and a browser or between two servers. Its primary purpose is
                  to protect sensitive information, such as personal or
                  financial information, from unauthorized access or hacker
                  theft.
                </motion.p>
              </div>
            </div>
          </div>
        </section>
        {/* blue text end  */}
        {/* table start */}
        <div className="container security-table-section">
          <div className="row ">
            <div className="col-12">
              <motion.h4
                className="security-circle-heading"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1 }}
              >
                SSL Features
              </motion.h4>
            </div>
          </div>
        </div>

        <section className="security-padding">
          <div className="">
            <div className="overflow-div">
              {/* <div className="">
                <div className="">
                  <div className=" table-static-div">
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p style={{ color: " #436fe8" }}>
                          SSL Full Features Comparison
                        </p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>Protects</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>Validation Type</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>Encryption Type</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>Benefits</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>SSL Issue Period</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>HTTPS & Padlock</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>Security Trust Seal</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>Green Address Bar</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>Supports</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>Free Relssues</p>
                      </div>
                    </h4>
                    <h4 className="table-cell-tag2">
                      <div className="cell-inner">
                        <p>Technical Support</p>
                      </div>
                    </h4>
                  </div>
                </div>
              </div> */}

              <AddToCartSecu />
            </div>
          </div>
        </section>
        {/* <AddToCartSecu /> */}
        {/* table end  */}
        {/* lock banner start */}

        <section className="security-section-margin">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 security-slider-img">
                <motion.img
                  initial={{ opacity: 0, scale: 0, x: 100 }}
                  whileInView={{ opacity: 1, scale: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                  className="img-fluid "
                  src="assest/photos/security/security-slider-img.png"
                  alt="G-Rank"
                  title="security"
                />
              </div>
              <div className="col-12 col-md-6 col-lg-6 align-self-center">
                <motion.h4
                  className="security-slider-heading"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  Why Choose Us?
                </motion.h4>

                <Slider {...settings2}>
                  <div className="testimonial-slider-div">
                    <div className="row">
                      <div className="col-12">
                        <p className="security-testimonial-slider-h1">
                          Comprehensive Protection
                        </p>
                        <motion.p
                          className="security-testimonial-slider-text"
                          initial={{ opacity: 0, scale: 0, y: 100 }}
                          whileInView={{ opacity: 1, scale: 1, y: 0 }}
                          transition={{ duration: 0.6 }}
                        >
                          Our solution covers a wide range of threats,
                          <br /> including hacking attempts, data breaches, and
                          <br />
                          unauthorized access, ensuring comprehensive
                          <br />
                          safeguarding of valuable data.
                        </motion.p>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-slider-div">
                    <div className="row">
                      <div className="col-12">
                        <p className="security-testimonial-slider-h1">
                          Strong Encryption
                        </p>
                        <motion.p
                          className="security-testimonial-slider-text"
                          initial={{ opacity: 0, scale: 0, y: 100 }}
                          whileInView={{ opacity: 1, scale: 1, y: 0 }}
                          transition={{ duration: 0.6 }}
                        >
                          Robust encryption techniques to secure <br />
                          sensitive information, making it extremely <br />
                          difficult for unauthorized individuals to
                          <br /> access and exploit data.
                        </motion.p>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-slider-div">
                    <div className="row">
                      <div className="col-12">
                        <p className="security-testimonial-slider-h1">
                          Seamless Integration
                        </p>
                        <motion.p
                          className="security-testimonial-slider-text"
                          initial={{ opacity: 0, scale: 0, y: 100 }}
                          whileInView={{ opacity: 1, scale: 1, y: 0 }}
                          transition={{ duration: 0.6 }}
                        >
                          Ease of implementation and integration
                          <br /> process allows clients to quickly and <br />
                          smoothly adopt their security solutions without
                          disruptions to <br />
                          their core business activities.
                        </motion.p>
                      </div>
                    </div>
                  </div>

                  <div className="testimonial-slider-div">
                    <div className="row">
                      <div className="col-12">
                        <p className="security-testimonial-slider-h1">
                          Customer-Focused Approach
                        </p>
                        <motion.p
                          className="security-testimonial-slider-text"
                          initial={{ opacity: 0, scale: 0, y: 100 }}
                          whileInView={{ opacity: 1, scale: 1, y: 0 }}
                          transition={{ duration: 0.6 }}
                        >
                          Our dedication to understanding and <br />
                          meeting the specific needs of each client, providing
                          tailored
                          <br /> security solutions and excellent customer
                          support.
                        </motion.p>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-slider-div">
                    <div className="row">
                      <div className="col-12">
                        <p className="security-testimonial-slider-h1">
                          Continuous Monitoring and Support
                        </p>
                        <motion.p
                          className="security-testimonial-slider-text"
                          initial={{ opacity: 0, scale: 0, y: 100 }}
                          whileInView={{ opacity: 1, scale: 1, y: 0 }}
                          transition={{ duration: 0.6 }}
                        >
                          We doesn't just set up security measures and <br />
                          forget about them; instead, we also offer ongoing
                          monitoring and support to ensure sustained protection
                          <br />
                          over time.
                        </motion.p>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </section>

        {/* lock banner end  */}
        {/* action yellow start*/}
        <div className="action-yellow-div-text">
          <motion.p
            initial={{ opacity: 0, scale: 0, y: 100 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Want to Elevate Your Brand?
            <br /> Get in Touch.
          </motion.p>
          <NavLink to="">
            <motion.p
              className="action-yellow-div-buttom"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              onClick={handleOpen}
            >
              Contact Us <ArrowRightAltIcon />
            </motion.p>
          </NavLink>
        </div>
        {/* action yellow end*/}
        {/* FAQs section start*/}
        <section>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <motion.h4
                  className="security-circle-heading"
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  FAQ's
                </motion.h4>
              </div>
              <div className="col-md-12">
                <div className="accordion" id="accordionExample">
                  <div className="card">
                    <div className="card-header" id="headingOne">
                      <h2 className="mb-0 panel-title">
                        <button
                          className="btn btn-link btn-block text-left"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          onClick={() => setOpen1(!open1)}
                        >
                          How do I install my SSL certificate?
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapseOne"
                      className="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="card-body-span">
                          The installation process for your SSL certificate
                          depends on where your site is hosted and your options
                          when purchasing the certificate. If you opt for web
                          hosting with Website Builder or Online Store, the
                          installation will be done for you. If you host your
                          website with another company or use G-Rank's VPS or
                          Dedicated Servers, you must follow specific
                          instructions provided by your hosting provider.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingTwo">
                      <h2 className="mb-0 panel-title">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                          onClick={() => setOpen2(!open2)}
                        >
                          What is an SSL certificate, and why do I need it?
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseTwo"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="card-body-span">
                          An SSL certificate, which stands for Secure Sockets
                          Layer, is a digital certificate that authenticates
                          websites and enables HTTPS encryption. It helps
                          protect the exchange of sensitive information between
                          visitors and a website. Installing an SSL certificate
                          on your site establishes trust with your visitors,
                          ensures secure transmission of user data, verifies
                          ownership of your website, and helps prevent attackers
                          from creating fraudulent versions of your site.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="headingThree">
                      <h2 className="mb-0 panel-title">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                          onClick={() => setOpen3(!open3)}
                        >
                          What is a Multi-Domain UC certificate / SAN
                          certificate?
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseThree"
                      className="collapse"
                      aria-labelledby="headingThree"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="card-body-span">
                          A Multi-Domain UC certificate, also known as a SAN
                          (Subject Alternative Names) certificate, is an SSL
                          certificate that can secure multiple domain names and
                          host names within a domain. With a single UCC SSL
                          certificate, you can protect a primary domain name and
                          up to 99 additional Subject Alternative Names. This
                          type of certificate is ideal for securing multiple
                          websites or domains under a single SSL certificate.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading4">
                      <h2 className="mb-0 panel-title">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapse4"
                          aria-expanded="false"
                          aria-controls="collapse4"
                          onClick={() => setOpen4(!open4)}
                        >
                          What is the difference between a Standard SSL
                          certificate and a Premium SSL certificate?
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapse4"
                      className="collapse"
                      aria-labelledby="heading4"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="card-body-span">
                          The main difference between a Standard SSL certificate
                          and a Premium SSL certificate is the level of
                          validation and the visual indicators in web browsers.
                          A Standard SSL certificate secures your website and
                          displays the https:// prefix in the URL address bar.
                          <br />
                          In contrast, a Premium SSL certificate, specifically
                          an Extended Validation (EV) SSL certificate, triggers
                          a green browser bar in most browsers, providing
                          enhanced visual assurance to visitors. Premium EV SSL
                          certificates require a more extensive vetting process,
                          including verifying the legal and physical existence
                          of the organization, and can take around 30 days to
                          issue.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading5">
                      <h2 className="mb-0 panel-title">
                        <button
                          className="btn btn-link btn-block text-left collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapse5"
                          aria-expanded="false"
                          aria-controls="collapse5"
                          onClick={() => setOpen5(!open5)}
                        >
                          What are the different types of SSL certificates?
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapse5"
                      className="collapse"
                      aria-labelledby="heading5"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="card-body-span">
                          G-Rank offers three types of SSL certificates:
                          <br />
                          Standard SSL certificate: This certificate encrypts
                          your website and displays the https:// prefix. It is
                          suitable for general website security needs.
                          <br />
                          Wildcard SSL certificate: A Wildcard SSL certificate
                          secures a domain and its unlimited number of
                          subdomains. It offers convenience and
                          cost-effectiveness for websites with multiple
                          subdomains.
                          <br />
                          Organizationally Validated (OV) SSL certificate: An OV
                          certificate involves a validation process where the
                          Certificate Authority verifies the organization,
                          physical address, and domain name. It provides
                          moderate trust and is suitable for public-facing
                          websites with lower-level transactions.
                          <br />
                          Extended Validation (EV) SSL certificate: An EV SSL
                          certificate offers the highest level of security. It
                          undergoes a thorough vetting process, including
                          verification of corporate documents, identity
                          confirmation, and third-party database checks. It is
                          recommended for websites dealing with sensitive
                          information.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* FAQs section end*/}
        {/* Quick Link section start */}
        <section>
          <div className="container-fluid">
            <div className="col-12">
              <motion.h4
                className="web-develop-header"
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1 }}
              >
                Quick Links For You
              </motion.h4>
            </div>
            <div>
              <Slider {...settings3}>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/branding-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Branding</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/creative-content-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Creative & <p className="d-block"> Content</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/organic-marketing-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Organic <p className="d-block"> marketing</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/performance-marketing-company"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Performance <p className="d-block"> marketing</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/social-media-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Social Media</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/web-development-agency"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Web <p className="d-block"> Development</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/domain"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Domain</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/hosting-service"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">
                      Web <p className="d-block"> Hosting</p>
                    </h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/web-security-services"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Security</h4>
                  </div>
                </NavLink>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/email-hosting-provider"
                  className=""
                >
                  <div className="slider-div2">
                    <h4 className="slider-img2">Email</h4>
                  </div>
                </NavLink>
              </Slider>
            </div>
          </div>
        </section>
        {/* Quick Link section end */}
        {/*Input start */}
        <section>
          <div className="performance-footerimg-div">
            <img
              className="img-fluid w-100"
              src="assest/photos/branding/branding-footer-img.png"
              alt="G-Rank"
              title="grank"
            />
            <div className="performance-footer-div-text">
              <h4>Learn more about our sevices</h4>
              <form className="searchArea" onSubmit={handleSubmit}>
                <button type="submit" tabindex="2">
                  Explore
                </button>
                <div className="inputDiv">
                  <input
                    type="text"
                    id="inputData"
                    name="inputData"
                    value={inputData}
                    onChange={(e) => setInputData(e.target.value)}
                    requiredtabindex="1"
                  />
                </div>
              </form>
            </div>
          </div>
        </section>
        {/*Input start */}
      </section>
    </>
  );
};

export default Security;
